import HeroSection from '@/components/layout/HeroSection/HeroSection';
import DocumentViewer from '@/components/document/DocumentViewer/DocumentViewer';
import PassagesPanel from '@/components/document/PassagesPanel/PassagesPanel';
import ContentRow from '@/components/content/ContentRow/ContentRow';
import DocumentTile from '@/components/content/DocumentTile/DocumentTile';
import { useAppSelector, useAppDispatch } from '@/app/hooks';
import { setMode } from '@/features/ui/uiSlice';
import MobileSearchBar from '@/components/ui/MobileSearchBar/MobileSearchBar';
import type { DocumentItem } from '@/types';
import styles from './Pages.module.css';

export default function DocumentIntelligencePage() {
  const { documentRows } = useAppSelector((s) => s.content);
  const dispatch = useAppDispatch();

  return (
    <div>
      {/* Mobile search bar — only visible on ≤767px, sits above tabs */}
      <MobileSearchBar />

      {/* Intelligence mode tabs */}
      <div className={styles.intelligenceTabs}>
        <button
          className={styles.intelligenceTab}
          onClick={() => dispatch(setMode('media'))}
        >
          Media Intelligence
        </button>
        <button
          className={`${styles.intelligenceTab} ${styles.intelligenceTabDisabled}`}
          disabled
        >
          Document Intelligence
          <span className={styles.comingSoonBadge}>Coming soon</span>
        </button>
      </div>

      {/* Hero */}
      <HeroSection
        badgeText="Spotlight Document · Indexed Nov 2025"
        badgeVariant="cyan"
        title="Lucihub Press Release — Multi-Language Voiceover Launch"
        player={<DocumentViewer />}
        sidePanel={<PassagesPanel />}
        description="Official press release announcing Lucihub’s multi-language voiceover feature, expanding the Creative Copilot suite. Smart Hub automatically extracted 3 pages, identified 10 key passages across the announcement, CEO quotes, and company overview, and cross-referenced related media assets."
        meta={{
          items: ['3 pages', '·', '1 author', '·', '✓ Public release', '·', 'PDF source', '·', 'Indexed in 0m 22s'],
          rightsIndex: 4,
        }}
        actions={[
          {
            label: 'Open document',
            variant: 'primary',
            icon: (
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
              </svg>
            ),
          },
          { label: 'Jump to CEO quote', variant: 'ghost' },
          { label: 'Share excerpt', variant: 'ghost' },
          { label: 'Download', variant: 'ghost' },
        ]}
      />

      {/* Content Rows */}
      <div className={styles.rows}>
        {documentRows.map((row) => (
          <ContentRow key={row.id} row={row}>
            {(row.items as DocumentItem[]).map((item) => (
              <DocumentTile key={item.id} item={item} />
            ))}
          </ContentRow>
        ))}
      </div>
    </div>
  );
}
